<div class="">
  <div *ngIf="widgets" class="interactions-overview">
    <p-table [value]="widgets"
             [paginator]="true"
             [loading]="!widgets"
             paginatorPosition="bottom"
             [totalRecords]="widgets.length"
             [rows]="pageSize" class="review_table">

      <ng-template pTemplate="emptymessage" let-columns>
        <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.WIDGET_TITLE' | translate }}</th>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.VISIBILITY' | translate}}</th>
          <th></th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entry>
        <tr>
          <td>
            {{entry.title}}
          </td>
          <td>
            {{getRoles(entry.roles)}}
          </td>
          <td>
            <div class="text-right" *gsShowIfHasPermission="['NDP_CUSTOM_WIDGETS_UPDATE', 'NDP_CUSTOM_WIDGETS_DELETE']">
               <span *gsShowIfHasPermission="['NDP_CUSTOM_WIDGETS_UPDATE']" class="pad-right-5">
              <i class="fa fa-pen edit-appointment"
                 pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.EDIT_TOOLTIP' | translate }}"
                 tooltipPosition="bottom"
                 (click)="modify(entry)"></i>
            </span>
              <span *gsShowIfHasPermission="['NDP_CUSTOM_WIDGETS_DELETE']" class="pad-right-5">
              <i class="fa fa-trash delete-appointment"
                 pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.DELETE_TOOLTIP' | translate }}"
                 tooltipPosition="bottom"
                 (click)="delete(entry)"></i>
            </span>
              <span class="pad-right-5">
                <i *ngIf="entry.orderNumber > 0" class="fa fa-angle-up move-appointment"
                   (click)="moveWidgetUp(entry)"
                   pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.MOVE_UP_TOOLTIP' | translate }}">
                </i>
                <i *ngIf="entry.orderNumber <= 0" class="empty-icon"></i>
            </span>
              <span class="pad-right-5" >
                <i *ngIf="entry.orderNumber < widgets?.length - 1"  class="fa fa-angle-down move-appointment"
                   (click)="moveWidgetDown(entry)"
                   pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TABLE_WIDGETS.MOVE_DOWN_TOOLTIP' | translate }}">
                </i>
                <i *ngIf="entry.orderNumber >= widgets?.length - 1" class="empty-icon"></i>
            </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div>
    <button pButton
            *gsShowIfHasPermission="['NDP_CUSTOM_WIDGETS_CREATE']"
            label="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.CREATE_BUTTON' | translate}}"
            (click)="add()"
            class="m-b-30">
    </button>
  </div>
</div>

<wsd-add-custom-widget (onSave)="onSave($event)" (onDelete)="delete($event)" [orderNumber]="widgets ? widgets.length : null">
</wsd-add-custom-widget>
